import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-grape/10 bg-white/70" data-id="element-17" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-18" data-mp="asz52k13em53">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-19" data-mp="frtl5e7odwli">
          🎁 5 Free Bonuses Included
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-20" data-mp="5w8pdxt79sk7">
          In addition to the main ebook, you also get these gifts — at no extra cost.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-21" data-mp="3t0g60ftkcee4">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-22" data-mp="3t2j5rrkiplw1" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} cover`} width={1024} height={1536} loading="lazy" className="h-auto w-20 shrink-0 self-start rounded-lg object-contain drop-shadow-[0_10px_18px_rgba(67,24,15,0.28)] sm:w-24" data-id="element-23" data-mp="3r7029t7sjrge" />
              <div className="flex min-w-0 flex-col" data-id="element-24" data-mp="2zg3wfck5en2m">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-25" data-mp="2uh0s5ubzskvp">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-26" data-mp="38g0h733f31se">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-27" data-mp="33ge36rfrlhij" /> Bonus {b.n}
                  </span>
                  <span className="text-sm font-bold" data-id="element-28" data-mp="nozzqtl08ea6">
                    <span className="text-plum/40 line-through" data-id="element-29" data-mp="iqyh29rhqgz8">{b.price}</span>{' '}
                    <span className="text-blush-deep" data-id="element-30" data-mp="it13ykxcjtzq">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-31" data-mp="3cl942ofx13pc">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3hg6enzsufl4c">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-33" data-mp="3qifmghwq90e1">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-34" data-mp="2tqc1fh4m3ujk">
            💰 Total bonus value: <span className="text-plum/50 line-through" data-id="element-35" data-mp="2xua1pv5obbe7">$148</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-36" data-mp="32s22zfs7k9v2">
              TODAY FREE WITH THE K-SMART VISUAL SYSTEM
            </span>
          </p>
        </div>
      </div>
    </section>;
}